import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=6839c0a4&scoped=true&"
import script from "./ActivityForm.vue?vue&type=script&lang=js&"
export * from "./ActivityForm.vue?vue&type=script&lang=js&"
import style0 from "./ActivityForm.vue?vue&type=style&index=0&id=6839c0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6839c0a4",
  null
  
)

export default component.exports